/* OMBA cart registry v2. Product-specific tiers; safe to load on every PDP. */
(function(global) {
  "use strict";
  const products = {
    "67628455952566": {handle:"desodorante-corporal",base:34.95,tiers:[[6,"COMPRA3LLEVA3",139.75],[4,"COMPRA2LLEVA2",84.85],[2,"COMPRA1LLEVA1",34.95]]},
    "67628460703926": {handle:"oxido-nitrico",base:34.95,tiers:[[3,"NITRICO3FRASCOS",34.9],[2,"NITRICO2FRASCOS",14.95]]},
    "67628464636086": {handle:"perimeno",base:34.95,tiers:[[6,"PERIMENO3X3",139.75],[4,"PERIMENO2X2",84.85],[2,"PERIMENO1X1",34.95]]},
    "67628469747894": {handle:"oxi-colon",base:34.95,tiers:[[6,"OXICOLON3X3",139.75],[4,"OXICOLON2X2",84.85],[2,"OXICOLON1X1",34.95]]}
  };
  const retiredCodes = Object.freeze(["NITRICO2MAS1", "NITRICO3MAS2", "NITRICO1X1", "NITRICO2X2", "NITRICO3X3"]);
  const quantities = cart => (cart.items || []).reduce((totals,item) => {
    const id=String(item.variant_id || item.id);
    totals[id]=(totals[id] || 0)+item.quantity;
    return totals;
  },{});
  function register(extra) {
    for (const [id,product] of Object.entries(extra)) {
      if (!/^\d+$/.test(id) || !product.tiers?.length) throw new Error("Registro de producto inválido");
      products[id]={...product,tiers:[...product.tiers].sort((a,b)=>b[0]-a[0])};
    }
  }
  function codes(cart, incoming=[]) {
    const qty=quantities(cart), known=new Set([...retiredCodes, ...Object.values(products).flatMap(p=>p.tiers.map(t=>t[1].toUpperCase()))]);
    const managed=Object.entries(products).flatMap(([id,p])=>{
      // Kaching validates this pack server-side; do not also request its legacy code.
      if(p.handle==="desodorante-corporal"){
        const lines=(cart.items||[]).filter(item=>String(item.variant_id||item.id)===id);
        if(lines.length && lines.every(item=>{try{const k=JSON.parse(item.properties?.__kaching_bundles||"null");return k?.main===true && k.deal && k.id && k.pp;}catch(_){return false;}})) return [];
      }
      const tier=p.tiers.find(t=>(qty[id] || 0)>=t[0]);
      return tier ? [tier[1]] : [];
    });
    const existing=(cart.discount_codes || []).filter(c=>c.applicable !== false).map(c=>c.code);
    const unrelated=[...existing,...incoming].filter(c=>typeof c==="string" && c.trim() && !known.has(c.trim().toUpperCase())).map(c=>c.trim());
    return [...new Set([...managed,...unrelated])];
  }
  global.OMBACartRegistry={version:2,products,retiredCodes,register,quantities,codes};
})(window);
